import { useState, useEffect } from 'react';
import { defaultValues } from '../config';
import { getDistance, isInBounds, getMapCenterFromBounds } from '../utilities';
import SpinnerMini from '../components/ui/SpinnerMini.js';

export function CountryList({ onChange, bounds }) {
  const [countries, setCountries] = useState([]);
  const [countryKey, setCountryKey] = useState(defaultValues.country.key);
  const [isLoading, setIsLoading] = useState(false);

  function handleSelect(e) {
    setCountryKey(e.target.value);
    onChange(countries.find((c) => c.key === e.target.value));
  }

  useEffect(
    function findNearestCountry() {
      if (!bounds || !countries) return;
      const mapCenter = getMapCenterFromBounds(bounds);

      const visibleCountries = countries.filter((c) =>
        isInBounds([c.latitude, c.longitude], bounds)
      );

      const nearestCountry = visibleCountries.reduce((nearest, c) => {
        c.distance = getDistance(mapCenter, [c.latitude, c.longitude]);
        return c.distance < nearest.distance ? c : nearest;
      }, visibleCountries[0]);

      if (nearestCountry?.key) setCountryKey(nearestCountry.key);
    },
    [countries, bounds]
  );

  useEffect(function () {
    async function getCountries() {
      setIsLoading(true);
      const res = await fetch(
        `https://raw.githubusercontent.com/grafana/worldmap-panel/91861ffa7fabcb5ffc38b89f27a7942195ff33fe/src/data/countries.json`
      );
      const data = await res.json();

      setCountries(data);
      setIsLoading(false);
    }
    setIsLoading(true);
    getCountries();
  }, []);

  return (
    <div className="form__row country-list">
      <label className="form__label" htmlFor="select-country">
        Country
      </label>
      <br />
      {isLoading && <SpinnerMini />}

      <select
        className="form__input form__input--type select-country"
        name="select-country"
        onChange={handleSelect}
        value={countryKey}
        disabled={isLoading}
      >
        {countries?.map((country) => (
          <Country country={country} key={country.key} />
        ))}
      </select>
    </div>
  );
}

export function Country({ country }) {
  return <option value={country.key}>{country.name}</option>;
}
